module.exports = __webpack_public_path__ + "static/media/ParcelImg.a8533354.png";